import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><g filter="none" fill="none" stroke="currentcolor"><path d="M13.003 3.154A7.072 7.072 0 113 3.154M0 .82l5.359.018-.03 5.31" filter="none"/></g></svg>`;

export { symbol as default };
